export function toTrackerItem(record) {
    const attention = record?.attention?.primary || '';
    const source = sourceLabel(record?.provenance);
    return {
        id: record.id,
        title: record.title || '',
        code: record.external_id || '',
        summary: record.description || '',
        description: record.description || '',
        businessFunction: record.business_function_raw || '',
        migrationType: record.migration_type_raw || 'Not specified',
        owner: record.owner_raw || 'Unassigned',
        status: record.status_label || record.status_canonical || 'Unknown',
        statusRaw: record.status_raw || '',
        statusConfirmed: Boolean(record.status_mapping_confirmed),
        statusCanonical: record.status_canonical || 'UNKNOWN',
        targetDate: record.target_date || '',
        attention,
        source,
        version: record.version || 1,
        customFields: record.custom_fields || {},
        customFieldEntries: record.custom_field_entries || [],
        sources: record.sources || [],
        revisions: record.revisions || [],
    };
}

export function sourceLabel(provenance) {
    if (provenance === 'MANUAL') return 'Added in Lens';
    if (provenance === 'CLIPBOARD') return 'Pasted in Lens';
    if (provenance === 'FILE') return 'Imported file';
    return provenance || 'Lens';
}

export function sourceLine(source) {
    const file = source?.filename || '';
    const sheet = source?.worksheet || '';
    if (file && sheet && file !== sheet) return `${file} · ${sheet}`;
    return file || sheet || '';
}

export function showsFileStatus(item) {
    const raw = (item?.statusRaw || '').trim();
    if (!raw || item?.statusConfirmed) return false;
    return raw.toLowerCase() !== (item.status || '').toLowerCase();
}

export function formatWhen(value, businessFunction) {
    if (!value) return businessFunction || '';
    const date = new Date(`${value}T00:00:00`);
    const label = Number.isNaN(date.getTime()) ? value : date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
    return businessFunction ? `${label} · ${businessFunction}` : label;
}
